import { Link } from "./ui/link";

export default function Footer() {
  return (
    <footer className="py-8 border-t">
      <div className="container mx-auto text-center">
        <p>&copy; {new Date().getFullYear()} PentAGI. All rights reserved.</p>
        <nav className="mt-4">
          <ul className="flex justify-center space-x-4 flex-wrap">
            <li>
              <Link href="https://github.com/vxcontrol/pentagi">GitHub</Link>
            </li>
            <li>
              <Link href="https://discord.gg/2xrMh7qX6m">Discord</Link>
            </li>
            <li>
              <Link href="https://t.me/+Ka9i6CNwe71hMWQy">Telegram</Link>
            </li>
            <li>
              <Link href="/privacy">Privacy Policy</Link>
            </li>
            <li>
              <Link href="/terms">Terms of Use</Link>
            </li>
            <li>
              <Link href="mailto:info@pentagi.com">Contact Us</Link>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
}
